import(/* webpackMode: "eager", webpackExports: ["PageContent"] */ "/home/runner/work/nextjs-newcars/nextjs-newcars/app/(routes)/info/[modelId]/[slug]/reviews/_components/page-content/component.tsx");
